export default (el) => {
    const selector = (el.dataset.useParentSelector && el.parentNode) || el;
    el.addEventListener('blur', function() {
        init();
    });

    el.addEventListener('change', function() {
        init();
    });

    // on page load
    init();

    function init() {
        if(el.value !== '') {
            selector.classList.add('-has-value');
        } else {
            selector.classList.remove('-has-value');
        }
    }
}
